export enum InvoicePaymentStatusEnum {
  PAID = "PAID",
  TOBEPAID = "TOBEPAID",
  TOBECONFIRMED = "TOBECONFIRMED",
  PROCESSING = "PROCESSING",
  FAILED = "FAILED",
}
